export default __webpack_public_path__ + "locales/pl/FillPDFDialog.json?hash=c585d22ccb47847c60ad700f4209ee30";